import { PRIVATE_SEARCH_TYPE } from '~/constants/localStorageKeys';

const DEFAULT_SEARCH_TYPE = 'keyword';

export type SearchType = 'keyword' | 'smart';

const isValidSearchType = (value: string | null): value is SearchType => {
  return value === 'keyword' || value === 'smart';
};

export const DEFAULT_CONTEXT = 'all';
export const getLocalStorageKey = (context: string) => `${PRIVATE_SEARCH_TYPE}/${context}`;

export const getLastUsedSearchType = (context: string) => {
  const localStorageKey = getLocalStorageKey(context);
  const lastUsedSearchType = localStorage.getItem(localStorageKey);

  return isValidSearchType(lastUsedSearchType) ? lastUsedSearchType : DEFAULT_SEARCH_TYPE;
};

export const setLastUsedSearchType = (type: SearchType, context: string) => {
  const localStorageKey = getLocalStorageKey(context);
  localStorage.setItem(localStorageKey, type);
};
